"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * NOrmaliza un string, generalmente para el envio de metrics
 * @param {string} str a transformar.
 * @returns {string} myExample --> my-example
 */
const normalizeString = (str) => {
    let newStr = str;
    newStr = newStr.toLowerCase();
    newStr = newStr.replace(/á/g, 'a');
    newStr = newStr.replace(/é/g, 'e');
    newStr = newStr.replace(/í/g, 'i');
    newStr = newStr.replace(/ó/g, 'o');
    newStr = newStr.replace(/ú/g, 'u');
    newStr = newStr.replace(/ /g, '-');
    newStr = newStr.replace(/-/g, '_');
    newStr = newStr.replace(/ñ/g, 'n');
    return newStr;
};
exports.default = normalizeString;
//# sourceMappingURL=index.js.map